<template>
    <multiselect
        class="w-1/3 mx-2"
        v-model="val"
        :options="provinceOptions"
        :searchable="true"
        :clearable="true"
        label="label"
        select-label=""
        deselect-label=""
    ></multiselect>
</template>

<script>
export default {
    name: 'ProvinceSelector',
    props: ['modelValue'],
    emits: ['update:modelValue'],
    data: () => ({
        val: null,
    }),
    computed: {
        provinceOptions() {
            return [
                {
                    label: "Alberta",
                    value: "AB"
                },
                {
                    label: "British Columbia",
                    value: "BC"
                },
                {
                    label: "Manitoba",
                    value: "MB"
                },
                {
                    label: "New Brunswick",
                    value: "NB"
                },
                {
                    label: "Newfoundland and Labrador",
                    value: "NL"
                },
                {
                    label: "Northwest Territories",
                    value: "NT"
                },
                {
                    label: "Nova Scotia",
                    value: "NS"
                },
                {
                    label: "Nunavut",
                    value: "NU"
                },
                {
                    label: "Ontario",
                    value: "ON"
                },
                {
                    label: "Prince Edward Island",
                    value: "PE"
                },
                {
                    label: "Quebec",
                    value: "QC"
                },
                {
                    label: "Saskatchewan",
                    value: "SK"
                },
                {
                    label: "Yukon Territory",
                    value: "YT"
                }
            ]
        }
    },
    mounted() {
        if (!this.modelValue) {
            this.val = null;
            return;
        }
        this.val = this.provinceOptions.find(option => option.value === this.modelValue);
    },
    watch: {
        modelValue() {
            this.val = this.provinceOptions.find(option => option.value === this.modelValue);
        },
        val(val) {
            if (!val) {
                this.$emit('update:modelValue', null);
                return;
            }
            this.$emit('update:modelValue', val.value);
        }
    }
};
</script>